import React from 'react';
import { useNavigate } from 'react-router-dom';
import './StaticPage.css';

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="static-page">
      <div className="static-page-header">
        <h2>プライバシーポリシー</h2>
        <button className="back-button" onClick={() => navigate('/')}>
          ← 戻る
        </button>
      </div>
      <div className="static-page-content">

        <h3>基本方針</h3>
        <p>
        当サイトで取得した個人情報は、お問い合わせに対する回答や必要な情報を連絡する際のみに利用し、他の目的では利用しません。
        </p>

        <h3>収集する情報</h3>
        <p>当サイトでは、以下の情報を収集することがあります。</p>
        <ul>
          <li>当サイトでは、ご利用者のアクセス情報をアクセスログという形で記録しています。アクセスログは、IPアドレス、ホスト名、位置情報、ブラウザ名、デバイス名等の情報を含んでいますが、特定の個人を特定できる情報は一切含まれておりません。アクセスログは、アクセス傾向を分析し、利便性の向上やウェブサイトの保守管理に利用し、それ以外の目的のために使用することはありません。</li>
          <li>当サイトは、Googleが提供するOAuth認証（Googleログイン）を利用しています。Googleログインをご利用の場合、Googleよりお客様の氏名・メールアドレス・プロフィール画像・GoogleアカウントIDを取得します。取得した情報はアカウントの作成・認証・サービス内表示の目的にのみ使用し、第三者への提供は行いません。Google社のプライバシーポリシーについては<a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">こちら</a>をご確認ください。</li>
          <li>当サイトでは、第三者配信の広告サービス（Googleアドセンス）を利用しており、ユーザーの興味に応じた商品やサービスの広告を表示するため、クッキー（Cookie）を使用しております。クッキーを使用することで当サイトはお客様のコンピュータを識別できるようになりますが、お客様個人を特定できるものではありません。</li>
        </ul>

        <h3>Google AdSense について</h3>
        <p>
          当サイトでは、Google が提供する広告サービス「Google AdSense」を利用しています。
          Google AdSense は Cookie を使用して、ユーザーの興味に基づいた広告を表示します。
          詳細は
          <a href="https://policies.google.com/technologies/ads" target="_blank" rel="noopener noreferrer">
            Google の広告ポリシー
          </a>
          をご確認ください。
        </p>

        <h3>プライバシーポリシーの変更</h3>
        <p>
          本プライバシーポリシーの内容は、必要に応じて変更することがあります。
          変更後のプライバシーポリシーは、本ページに掲載した時点から効力を生じるものとします。
        </p>

        <h3>お問い合わせ</h3>
        <p>
          本プライバシーポリシーに関するお問い合わせは、
          <a href="https://x.com/nysalor" target="_blank" rel="noopener noreferrer">X (Twitter)</a>
          もしくは
          <a href="https://bsky.app/profile/nysalor.bsky.social" target="_blank" rel="noopener noreferrer">Bluesky</a>
          までお願いします。
        </p>

        <p className="last-updated">制定・最終更新: 2026年6月</p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
